import React from 'react';
import * as PropTypes from 'prop-types';

import {imageUrl} from '../../../helpers/ApplicationHelper';

const Review = (props) => {
  let {content: {link, logo, text, user, platform}, onClickEvent} = props;
  let linkProps = {
    href: link,
    onClick: onClickEvent,
    'data-label': platform,
    'data-section': 'Review'
  };

  return (
      <div className={'review'}>
        <div className="platform-n-stars">
          <a className="platform" {...linkProps}><img src={logo} alt="platform logo" /></a>
            <img className='stars' src={imageUrl('homepage/stars.svg')} alt='stars'/>
        </div>

        <div className="content">
          <div className="text">{text}</div>
          <div className='user-name'>{user}.</div>
        </div>

        <a className="link" {...linkProps}>More {platform} reviews &gt;</a>
      </div>
  )
};

Review.propTypes = {
  content:PropTypes.object,
  onClickEvent:PropTypes.func
};

Review.defaultProps = {
  content: {link: '', logo: '', text: '', user: '', platform: ''}
};


export default Review